/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

'use strict';
angular.module('prism-ui.components.data').factory('AcceptProfileResourceFactory', function ($resource, EndPointService) {
    return $resource(EndPointService.acceptProfileEndPoint, {mediaType: '@mediaType'}, {

        hideAcceptProfile: {
            method: 'DELETE',
            url: EndPointService.acceptProfileEndPoint + '/:id'
        },

        getAcceptProfile: {
            method: 'GET',
            url: EndPointService.acceptProfileEndPoint + '/:id'
        },

        cloneAcceptProfile: {
            method: 'POST',
            url: EndPointService.acceptProfileEndPoint + '/:id',
            params: {
                id: '@id'
            }
        },
        getValidators: {
            method: 'GET',
            params: {
                includeHidden: '@includeHidden'
            },
            isArray: true,
            url: EndPointService.acceptProfileEndPoint + '/:profileId/validators'
        },
        updateValidators: {
            method: 'PUT',
            isArray: true,
            url: EndPointService.acceptProfileEndPoint + '/:profileId/validators'
        },
        updateValidatorsFromMedia: {
            method: 'PUT',
            params: {
                mediaPath: '@mediaPath',
                profileId: '@profileId',
            },
            isArray: true,
            url: EndPointService.acceptProfileEndPoint + '/:profileId/validatorsFromMediaInfo'
        },
        toggleValidatorVisibility: {
            method: 'DELETE',
            url: EndPointService.acceptProfileEndPoint + '/validators/:id'
        }
    });
});
